import { createMixin } from "component-register";

export const withCSS = (styles: string) =>
  createMixin((options) => {
    const { element } = options;
    const stylesheet = new CSSStyleSheet();
    if ("adoptedStyleSheets" in element.renderRoot) {
      stylesheet.replaceSync(styles);
      element.renderRoot.adoptedStyleSheets = [stylesheet];
    }
    return { ...options, element };
  });
